import { useState, useEffect } from "react";
import { useLenis } from "lenis/react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Method", id: "manifesto" },
  { label: "Coaching", id: "services" },
  { label: "Angelo", id: "about" },
  { label: "Results", id: "testimonials" },
];

export const Navbar = () => {
  const lenis = useLenis();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el && lenis) lenis.scrollTo(el, { offset: -20 });
    else if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("top")}
          className="font-display text-xl md:text-2xl tracking-tight leading-none text-left"
        >
          LATTE STONE<span className="text-[#e5ff00]">.</span>
          <span className="block text-[9px] tracking-[0.3em] text-white/50 font-condensed">
            ATHLETICS · TRAINING & PERFORMANCE
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-xs uppercase tracking-[0.2em] text-white/70 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta"
            onClick={() => go("booking")}
            className="bg-[#e5ff00] text-black text-xs uppercase tracking-[0.2em] font-bold px-5 py-3 rounded-full hover:neon-glow transition-shadow duration-300"
          >
            Apply Now
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white p-2"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-5 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-sm uppercase tracking-[0.2em] text-white/80"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-cta"
            onClick={() => go("booking")}
            className="bg-[#e5ff00] text-black text-sm uppercase tracking-[0.2em] font-bold px-5 py-3 rounded-full"
          >
            Apply Now
          </button>
        </div>
      )}
    </header>
  );
};
